// extracted by mini-css-extract-plugin
export default {"root":"shared-module__root__SlY5ApD","fontSmoothing":"shared-module__fontSmoothing__zk8EseG","SubNav__spacer":"shared-module__SubNav__spacer__Wvk6BPp"};